/* eslint-disable camelcase */
import { FetchPolicy } from '@bingads-webui-react/overreact';
import { composeSearchString } from '@bingads-webui-react/overreact-odata';
import { getDefaultHeaderObj } from '@bingads-webui/overreact-bingads';

import { edm } from '../../../../../../env/edm';

export const networkPolicy = FetchPolicy.NetworkOnly;

export function urlDecorator(fn) {
  function decorator(params) {
    const { variables } = params;
    const { locator: { descriptor }, ...rest } = variables;
    const {
      customer_id,
      account_id,
    } = descriptor;

    const edmEntity = edm
      .Customers.$withKey(customer_id)
      .Accounts.$withKey(account_id)['Default.LoadCalendar']
      .$call(rest);

    const searchString = composeSearchString(variables, edmEntity, true);
    return `${edmEntity.path}${searchString}`;
  }

  return params => decorator(params, fn(params));
}

export function headerDecorator(fn) {
  function decorator() {
    return getDefaultHeaderObj();
  }

  return params => decorator(params, fn(params));
}

export function payloadDecorator(fn) {
  function decorator(params, originValue) {
    // TODO: Add decoration
    return originValue;
  }

  return params => decorator(params, fn(params));
}

export function keySelectorDecorator(fn) {
  function decorator(obj, originValue) {
    // TODO: Add decoration
    return originValue;
  }

  return obj => decorator(obj, fn(obj));
}

export function processorDecorator(fn) {
  function decorator(response) {
    return response && response.value;
  }

  return (response, request) => decorator(response, request, fn(response, request));
}

export const sideEffects = {
  fetch: null,
  refetch: null,
  mutation: null,
  pagination: null,
  add: null,
  destroy: null,
};
